module.exports = __webpack_public_path__ + "static/acc2-ce8b35ef3702aef9c3b3518a50f30a94.jpg";